<template>
  <cms-parallax
    v-if="parallaxContent"
    :config="parallaxSetUp"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewParallax' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();

const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const parallaxSetUp = computed(() => homepage.value.parallax[id.value]);

const parallaxContent = computed(() => !isEmpty(homepage.value?.parallax?.[id.value]?.background_image));
</script>
